<template>
    <BCard no-body>
        <BCardBody>
            <BCardTitle> Accesos recientes </BCardTitle>
            <BCardSubTitle> Últimos accesos del usuario a la plataforma </BCardSubTitle>
        </BCardBody>
        <BTable striped responsive :items="userData.access_logs" :fields="fields" class="mb-0" empty-text="Sin accesos recientes" show-empty :sort-desc="true" sort-by="logging_date" :per-page="perPage" :current-page="currentPage">
            <template #cell(logging_date)="data">
                {{ new Intl.DateTimeFormat('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute:'2-digit' }).format(new Date(data.item.logging_date)) }}
            </template>
        </BTable>
        <!-- Pagination -->
        <BPagination v-model="currentPage" :total-rows="total" :per-page="perPage" first-number last-number class="mx-2 my-2" prev-class="prev-item" next-class="next-item" >
            <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
        </BPagination>
    </BCard>
</template>

<script>
import { BCard, BCardBody, BCardSubTitle, BCardTitle, BCol, BPagination, BRow, BTable } from 'bootstrap-vue';
import { formatDate } from '@core/utils/filter';
import { ref } from '@vue/composition-api';

export default {
    components: { BCard, BCardTitle, BCardSubTitle, BTable, BCardBody, BPagination, BRow, BCol },
    props: [ 'userData' ],
    setup(props){
        const access_logs = ref(props.userData.access_logs)
        const total = ref(access_logs.value.length)
        const perPage = ref(10)
        const currentPage = ref(1)
        const fields = [
            { key: 'ip', label: 'IP' },
            { key: 'logging_date', label: 'Fecha de acceso' }
        ]

        return {
            currentPage,
            formatDate,
            perPage,
            fields,
            total
        }
    }
}
</script>

<style>

</style>
